
<div id="dropzone" class="dropzone" [ngClass]="!mediaObject?.media?.name?'dash-border':'hgt-24'" ngFileDrop [options]="options" (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput">
    <div class="area" >
        <ng-container *ngIf="!mediaObject?.media?.name">
        <span class="btn btn-link link-primary ctlInputFile no-all-pad" > 
            <input id="ctlNewFileID" #ctlNewFileID type="file" class="wid-200" style="font-size: 0;" accept=".png, image/jpeg, image/gif ,.jpg ,image/bmp , audio/mp3 , audio/wav , audio/aac , .mp4 , video/3gpp ,.txt, .pdf, .doc, .docx, .ppt, .pptx, .xls, .xlsx" name="file-upload" ngFileSelect [options]="options" (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput">
            <div class="marT15"><span class="eds-link">{{'Choose your content file' | translate}}</span><span><i class="icon icon-upload eds-link padL10"></i></span></div>
        </span>
        </ng-container>
        <ng-container *ngIf="mediaObject?.media?.name">
        <span class="btn btn-link link-primary ctlInputFile no-all-pad" >
            <input id="ctlNewFileID" #ctlNewFileID type="file" class="wid-288" style="font-size: 0;" accept=".png, image/jpeg, image/gif ,.jpg ,image/bmp , audio/mp3 , audio/wav , audio/aac , .mp4 , video/3gpp ,.txt, .pdf, .doc, .docx, .ppt, .pptx, .xls, .xlsx" name="file-upload" ngFileSelect [options]="options" (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput">
            <div class="marT15 spaceBtwn"><span class="eds-link padL5">{{mediaObject?.media?.name}}</span><span><i class="icon icon-upload"></i></span></div>
        </span>
        </ng-container>
    </div>
    <div class="upload-items">
        <div class="upload-item" *ngFor="let f of files; let i = index;">
            <span class="filename">
            <span>{{ f.name }} ({{ f.id }}) - {{ f.progress?.data?.percentage }}%</span>
            <span>uploading with {{ f.progress?.data?.speedHuman }}</span>
            <span>ETA {{ f.progress?.data?.etaHuman }}</span>
            </span>
            <div class="progress">
                <span class="bar" [style.width]="f?.progress?.data?.percentage + '%'"></span>
            </div>
        </div>
    </div>
</div>
